import { Employment } from 'src/app/shared/models/employment.model';

function hasText(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

function phoneHasEnoughDigits(phone: string | undefined | null): boolean {
  if (!phone) {
    return false;
  }
  const digits = String(phone).replace(/\D/g, '');
  return digits.length >= 10;
}

function hasValidEmail(email: string | undefined | null): boolean {
  if (!hasText(email)) {
    return false;
  }
  const e = email!.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

/** Normalizes UI/API variants like "companyDriver", "Company Driver". */
function normalizedPositionKey(position: string): string {
  return position.trim().toLowerCase().replace(/\s+/g, '');
}

/**
 * True when an employment row still needs the same mandatory details the driver would
 * have to enter on the employed form (e.g. carrier-hire auto-created records).
 * Gap placeholders and unemployment rows are never flagged.
 */
export function isEmployedRecordMissingMandatoryFields(emp: Employment | null | undefined): boolean {
  if (!emp || !emp.fromDate) {
    return false;
  }
  if (emp.employmentState === 'unemployed') {
    return false;
  }
  if (emp.employmentState && emp.employmentState !== 'employed') {
    return false;
  }

  if (!hasText(emp.employer)) {
    return true;
  }
  if (!hasText(emp.employerAddress)) {
    return true;
  }

  const positionRaw = (emp.position || '').trim();
  if (!hasText(positionRaw) || positionRaw === '-') {
    return true;
  }

  const pk = normalizedPositionKey(positionRaw);
  if (pk === 'companydriver' || pk === 'owneroperator') {
    if (!hasText(emp.licenseType)) {
      return true;
    }
    if (!hasText(emp.assignedRadius)) {
      return true;
    }
    const types = emp.equipmentTypes;
    if (!Array.isArray(types) || types.length === 0) {
      return true;
    }
    if (!hasText(emp.referenceContactName)) {
      return true;
    }
    if (!phoneHasEnoughDigits(emp.referenceContactPhoneNumber)) {
      return true;
    }
    if (!hasValidEmail(emp.referenceEmail)) {
      return true;
    }
  }

  return false;
}
